import React from 'react';
import PropTypes from 'prop-types';

export const buttonProps = {
    label: PropTypes.string.isRequired,
    style: PropTypes.shape({}),
    href: PropTypes.string,
    onClick: PropTypes.func
};